export type WorldFactionId = "infernal" | "celestial" | "ephemeral" | "factionless";

/** Outer faction carousel order; first is default on load. */
export const FACTION_CAROUSEL_ORDER: WorldFactionId[] = [
  "infernal",
  "celestial",
  "ephemeral",
  "factionless",
];

export type FactionHeroSlide = {
  alt: string;
  jsonFile: string;
  atlasFile: string;
};

export const FACTION_HEROES: Record<WorldFactionId, FactionHeroSlide[]> = {
  infernal: [
    { alt: "Jhah Assassin", jsonFile: "Jhah_Assassin.json", atlasFile: "Jhah_Assassin.atlas.txt" },
    { alt: "Lyrpa", jsonFile: "Lyrpa.json", atlasFile: "Lyrpa.atlas.txt" },
    { alt: "Voidcaster", jsonFile: "Voidcaster.json", atlasFile: "Voidcaster.atlas" },
  ],
  celestial: [
    { alt: "Alari", jsonFile: "Alari.json", atlasFile: "Alari.atlas" },
    { alt: "Aezramn", jsonFile: "Aezramn.json", atlasFile: "Aezramn.atlas.txt" },
    { alt: "Furion", jsonFile: "Furion.json", atlasFile: "Furion.atlas.txt" },
  ],
  ephemeral: [
    { alt: "Naaz", jsonFile: "Naaz.json", atlasFile: "Naaz.atlas" },
    { alt: "Minora", jsonFile: "Minora.json", atlasFile: "Minora.atlas" },
    { alt: "Borctor", jsonFile: "Borctor_the_Swampking.json", atlasFile: "Borctor_the_Swampking.atlas.txt" },
  ],
  factionless: [
    { alt: "Dark Wanderer", jsonFile: "Dark Wanderer.json", atlasFile: "Dark Wanderer.atlas.txt" },
    { alt: "Corynia", jsonFile: "Corynia.json", atlasFile: "Corynia.atlas" },
    { alt: "Raynald", jsonFile: "Raynald.json", atlasFile: "Raynald.atlas.txt" },
  ],
};

export type FactionCopy = {
  title: string;
  subtitle: string;
  description: string;
  /** Five headline strengths; replace with final copy later. */
  strengths: [string, string, string, string, string];
};

export const FACTION_COPY: Record<WorldFactionId, FactionCopy> = {
  infernal: {
    title: "Infernals",
    subtitle: "THE VOIDFORGED",
    description:
      "Infernals are among the most ruthless and powerful factions in the world of Dfiance. They are fueled by chaos, sacrifice, and relentless aggression",
    strengths: [
      "Strongest direct damage tools.",
      "Very powerful sacrifice payoff cards.",
      "Excellent board clearing.",
      "Strong discard pile synergy.",
      "High-pressure aggressive gameplay.",
    ],
  },
  celestial: {
    title: "Celestials",
    subtitle: "THE DESPERATE",
    description:
      "Winged warriors who wield light, discipline, and overwhelming battlefield control. They are known for their precision and efficiency.",
    strengths: [
      "Strong fly synergy allows them to gain temporary immunity to certain effects.",
      "Excellent ally-wide buffing.",
      "Strong revive/Medic support.",
      "Very high late-game ATK scaling.",
      "Excellent board swarming.",
    ],
  },
  ephemeral: {
    title: "Ephemerals",
    subtitle: "THE NATIVES",
    description:
      "Masters of magic in all its forms - Be it illusion, decay, or manipulation, Ephemerals bend reality itself to their will.",
    strengths: [
      "Strongest spell synergy faction.",
      "Excellent card generation/draw.",
      "Powerful mana acceleration and strong scaling from repeated spell casting.",
      "Flexible hand manipulation.",
      "Excellent resource cycling and high combo potential.",
    ],
  },
  factionless: {
    title: "Factionless",
    subtitle: "THE UNDESIRABLES",
    description:
      "Mercenaries, monsters, deserters, wanderers, and rogue powers untethered from any single allegiance.",
    strengths: [
      "Versatile toolbox that adds utility and tech options to any deck.",
      "Helps cover faction weaknesses and boosts faction synergy.",
      "Provides flexible removal/disruption tools.",
      "Enables unique deck customization.",
      "Excellent counter/meta tools; improve consistency or tempo in specialized builds.",
    ],
  },
};
